import axios from 'axios';

const API_URL = 'https://ksgfg8bf42.execute-api.us-east-1.amazonaws.com/prod/news';

export const GetLatestNews = async (recType) => {
  try {
    const response = await axios.get(API_URL, {
      params: {
        recType: recType
      },
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};


export const GetOlderNews = async (recType) => {
  try {
    const response = await axios.get(API_URL, {
      params: {
        recType: recType
      },
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

